import {TableColumnWidthUnit} from './table-column-width-unit';

export class Px implements TableColumnWidthUnit {

    public static readonly unitNumberSuffix = 'px';

    public static mapToPx(widths: Px[], totalPx: number): number[] {
        return widths.map(width => width.toPx(totalPx));
    }

    constructor(
        public value: number
    ) {}

    public toPx(totalPx: number): number {
        return Math.min(this.value, totalPx);
    }

    public adjustToPx(oldValuePx: number, newValuePx: number): void {
        this.value = newValuePx;
    }

    public toString(): string {
        return `${this.value}${Px.unitNumberSuffix}`;
    }

}
